import { render, staticRenderFns } from "./MoodVideo.vue?vue&type=template&id=32fae27d&"
import script from "./MoodVideo.vue?vue&type=script&lang=js&"
export * from "./MoodVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports